import { ref } from 'vue'

const residentialId = ref(
  document.querySelector( '#app-novostroy' ).dataset.residentialId
)

export {
  residentialId
}